(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('productBox', ProductBox)

    /** @ngInject */
    function ProductBox($timeout, ProductService, HelperService, AuthenticationService, UnavailableProductService, NotifyService, PATHS) {
        function ProductBoxController() {
            const vm = this;
            const cartProducts = ProductService.getProducts();

            vm.getProductImage = product => {
                return HelperService.imageHandlerPath('product', product.Id, product.Image);
            }

            vm.getProductGalleryImage = gallery => {
                return HelperService.imageHandlerPath('product', gallery.ProductId, gallery.Image);
            }

            vm.getProductStock = product => {
                let stock = false;

                if (ProductService.isNetSuiteProduct(product))
                    stock = product.ProductValue[0].StockAvailable;

                return stock;
            }

            vm.onGalleryClick = $e => {
                $e.preventDefault();
            }

            vm.addItemToCart = (product, isFromModal, hasSelectUnit = false) => {
                let units = AuthenticationService.getUnits();

                units = units.filter(x => x.HeadUnitId != null);

                vm.selectedProduct = product;

                if (isFromModal)
                    HelperService.hideModal('#details-modal');

                if (units.length > 1 && !hasSelectUnit) {
                    vm.units = units;

                    $timeout(() => {
                        HelperService.showModal('#select-unit');
                    });

                    return;
                } else if (hasSelectUnit) {
                    if (!vm.selectedUnit) {
                        HelperService.setErrorMessageForm('.unit');
                        return;
                    }

                    product.UnitId = vm.selectedUnit.Id;
                } else
                    product.UnitId = AuthenticationService.getSelectedUnit().Id;

                product.Unit = units.find(unit => (unit.Id == product.UnitId));

                vm.selectedUnit = null;
                HelperService.hideModal('#select-unit');

                HelperService.startLoading('.cart-holder');

                ProductService.addProduct(product);

                HelperService.stopLoading('.cart-holder');
            }

            vm.hasSelectedProduct = () => {
                return vm.selectedProduct != null;
            }

            vm.hasProductStock = product => {
                const productValue = product.ProductValue[0];

                const cartProductAmount = cartProducts.reduce((acc, cur) => {
                    if (cur.Id == product.Id)
                    acc += cur.Amount;

                    return acc;
                }, 0);

                if (ProductService.isNetSuiteProduct(product))
                    return (productValue.StockAvailable - cartProductAmount) >= 1;

                return productValue.StockAvailable >= 1;
            }

            vm.canUnitBuy = () => {
                const unit = AuthenticationService.getSelectedUnit();

                return unit.HeadUnitId != null;
            }

            vm.showProductDetails = product => {
                vm.selectedProduct = product;

                $timeout(() => {
                    HelperService.showModal('#details-modal');
                });
            }

            vm.showUnavailableForm = productId => {
                vm.unavailableProduct = {
                    ProductId: productId
                };

                $timeout(() => {
                    HelperService.showModal('#unavailable-product');
                });
            }

            vm.onCloseModal = () => {
                vm.selectedProduct = null;
                vm.selectedUnit = null;

                vm.unavailableForm.reset();
                vm.unavailableProduct = null;
            }

            vm.sendUnavailableForm = () => {
                HelperService.startLoading('.modal-holder');

                vm.unavailableProduct.UnitId = AuthenticationService.getSelectedUnit().Id;
                vm.unavailableProduct.PersonId = AuthenticationService.getUserId();
                vm.unavailableProduct.Informed = false;

                UnavailableProductService
                    .post(vm.unavailableProduct)
                    .then(
                        success => {
                            NotifyService.success("Solicitação enviada com sucesso!");
                            vm.unavailableForm.reset();

                            HelperService.hideModal('#unavailable-product');
                            HelperService.stopLoading('.modal-holder');
                        }, error => {
                            HelperService.errorCallback(error);
                            HelperService.stopLoading('.modal-holder');
                        }
                    )
            }

            init();

            function init() {
                vm.isProvider = AuthenticationService.getSelectedData().ResponsibilityId == 8;
                vm.isFranchiser = AuthenticationService.getSelectedData().AccessLevelId == 1;

                vm.galleryOptions = {
                    margin: 15,
                    dots: false,
                    autoHeight: true,
                    nav: true,
                    autoplay: true,
                    navText: [
                        "<button type='button' class='btn btn-carousel left'><i class='icomoon-arrow-left'></i></button>",
                        "<button type='button' class='btn btn-carousel right'><i class='icomoon-arrow-right'></i></button>"
                    ]
                }
            }
        }

        return {
            bindToController: true,
            controller: ProductBoxController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/product-box/product-box.html`,
            scope: {
                products: '='
            }
        }
    }
}());